module.exports = __webpack_public_path__ + "img/release the risk@2x.5e7429bc.png";